<div id="container">
  <div id="icon">
    <mat-icon fontSet="mdi" [fontIcon]="icon" [style.color]="colour" [ngClass]="size"></mat-icon>
  </div>
  <div class="line-break">
    <ng-content></ng-content>
  </div>
</div>
